const defaultTheme = {
  fonts: {
    heading: "Roboto",
    body: "Roboto",
  },
  fontSizes: {
    h1: "3.375rem", // 54px
    h2: "3rem", // 48px
    h3: "2.5rem", // 40px
    h4: "2rem", // 32px
    subHeading1: "1.5rem", // 24px
    subHeading2: "1.25rem", // 20px
    body: "1.0625rem", // 17px
    caption: "0.875rem", // 14px
    label: "0.75rem", // 12px
  },
  lineHeights: {
    default: 1.2,
    md: 1.25,
    lg: 1.3,
    h1: "4.05rem", // 64.8px
    h2: "3.6rem", // 57.6px
    h3: "3rem", // 48px
    h4: "2.4rem", // 38.4px
    subHeading1: "1.8rem", // 28.8px
    subHeading2: "1.5rem", // 24px
    body: "1.275rem", // 20.4px
    caption: "1.05rem", // 16.8px
    label: "0.9rem", // 14.4px
  },
  colors: {
    primary: {
      main: "#800020",
      dark: "#4D0013",
      light: "#E5CCD2",
    },
    secondary: {
      main: "#02122A",
      light: "#8C9AAE",
    },
    bg: {
      main: "#EFFAB0",
      paper: "#F8F7EF",
    },
    progress: {
      main: "#29A32E",
    },
    divider: "#CDD4DD",
    info: "#1655B2",
    success: "#29A32E",
    error: "#FF0F00",
    warning: "#FF0F00",
    disabled: "#CDD4DD",
    scrollbar: {
      primary: "#C4342B",
      secondary: "#8C9AAE",
    },
  },
  radii: {
    md: "0.25rem",
    lg: "0.5rem",
    round: "50%",
  },
  space: {
    xs: "0.25rem",
    sm: "0.5rem",
    md: "0.75rem",
    lg: "1rem",
    xl: "1.5rem",
    xxl: "2rem",
    "3xl": "2.5rem",
    "4xl": "5rem",
    "8xl": "8rem",
    "9xl": "9rem",
    "10xl": "10rem",
    "11xl": "15rem",
  },
  // components: {
  //   Button,
  //   Input: inputTheme
  // }
};
const theme = {
  default: defaultTheme,
};

export type Theme = typeof defaultTheme;
type Color = typeof defaultTheme.colors;
export type ThemeColor = keyof Color;
export default theme;
